// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/promotion.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.PromotionRule
 */
export const PromotionRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PromotionRule",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "starts_at", kind: "message", T: Timestamp },
    { no: 8, name: "ends_at", kind: "message", T: Timestamp },
    { no: 9, name: "conditions", kind: "message", T: PromotionCondition, repeated: true },
    { no: 10, name: "actions", kind: "message", T: PromotionAction, repeated: true },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.PromotionCondition
 */
export const PromotionCondition = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PromotionCondition",
  () => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "operator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PromotionAction
 */
export const PromotionAction = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PromotionAction",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreatePromotionRuleRequest
 */
export const CreatePromotionRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePromotionRuleRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "starts_at", kind: "message", T: Timestamp },
    { no: 5, name: "ends_at", kind: "message", T: Timestamp },
    { no: 6, name: "conditions", kind: "message", T: PromotionCondition, repeated: true },
    { no: 7, name: "actions", kind: "message", T: PromotionAction, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePromotionRuleRequest
 */
export const UpdatePromotionRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePromotionRuleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "starts_at", kind: "message", T: Timestamp },
    { no: 7, name: "ends_at", kind: "message", T: Timestamp },
    { no: 8, name: "conditions", kind: "message", T: PromotionCondition, repeated: true },
    { no: 9, name: "actions", kind: "message", T: PromotionAction, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeletePromotionRuleRequest
 */
export const DeletePromotionRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePromotionRuleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPromotionRuleRequest
 */
export const GetPromotionRuleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPromotionRuleRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPromotionRulesRequest
 */
export const ListPromotionRulesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPromotionRulesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPromotionRulesResponse
 */
export const ListPromotionRulesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPromotionRulesResponse",
  () => [
    { no: 1, name: "rules", kind: "message", T: PromotionRule, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.EvaluatePromotionsRequest
 */
export const EvaluatePromotionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvaluatePromotionsRequest",
  () => [
    { no: 1, name: "order_total_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "item_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "customer_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "customer_segment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.EvaluatePromotionsResponse
 */
export const EvaluatePromotionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvaluatePromotionsResponse",
  () => [
    { no: 1, name: "applied", kind: "message", T: AppliedPromotion, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AppliedPromotion
 */
export const AppliedPromotion = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AppliedPromotion",
  () => [
    { no: 1, name: "rule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rule_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "discount_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

